export const FIELD_WORK_ORDERS_COUNT = 'FIELD_WORK_ORDERS_COUNT';
export const FIELD_WORK_ORDERS_LOAD = 'FIELD_WORK_ORDERS_LOAD';
